var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "25",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          d:
            "M2 2.617c0-.34.28-.617.625-.617s.625.276.625.617v18.519c0 .34-.28.617-.625.617A.621.621 0 0 1 2 21.136V2.617Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "currentColor",
          d:
            "M2 21.383c0-.341.28-.618.625-.618h18.75c.345 0 .625.277.625.618 0 .34-.28.617-.625.617H2.625A.621.621 0 0 1 2 21.383ZM15 3.605c0-.341.28-.617.625-.617h4.35c.345 0 .625.276.625.617 0 .34-.28.617-.625.617h-4.35A.621.621 0 0 1 15 3.605Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "currentColor",
          d:
            "M19.35 3.605c0-.341.28-.617.625-.617s.625.276.625.617V7.9c0 .341-.28.618-.625.618a.621.621 0 0 1-.625-.618V3.605Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d:
            "M13.168 12.647c-.744.301-1.534.183-2.422-.206-1.6-.703-3.067.12-4.477 1.606-.689.726-1.309 1.556-1.863 2.318l-.19.261c-.463.64-.903 1.246-1.274 1.613l-.884-.873c.293-.289.664-.8 1.15-1.47l.183-.252c.555-.762 1.216-1.65 1.965-2.44 1.465-1.545 3.498-2.945 5.898-1.892.734.323 1.142.313 1.44.193.338-.138.693-.478 1.184-1.176.264-.374.555-.836.894-1.373.865-1.371 2.04-3.233 3.848-5.376l.96.79c-1.75 2.075-2.832 3.792-3.688 5.149-.358.568-.677 1.074-.988 1.515-.504.715-1.034 1.328-1.736 1.613Z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }